<template>
  <div class="product">
    <md-dialog-confirm
      :md-active.sync="dialog"
      md-title="Пометить собранным"
      md-content="Пометить товар, как собранный"
      md-confirm-text="Да"
      md-cancel-text="Нет"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
    <md-card style="position: relative">
      <md-card-header class="custom-overflow-card-header">
        <div
          v-if="
            product.hasReplacement &&
            (!product.replacemens || !product.replacemens.length)
          "
        >
          <md-icon>change_history</md-icon>
        </div>
        <div
          v-if="
            product.hasReplacement &&
            product.replacemens &&
            product.replacemens.length
          "
        >
          <div v-for="replacement in product.replacemens" :key="replacement.id">
            <router-link
              :to="{ name: 'replacement', params: { id: replacement } }"
            >
              <md-icon class="md-primary">change_history</md-icon>
            </router-link>
          </div>
        </div>
      </md-card-header>
      <md-card-media-cover>
        <img
          v-on:click.prevent="selectProduct(product)"
          :src="image"
          :alt="product.name"
          style="width: 100%"
        />

        <md-card-area class="card-area">
          <md-card-header>
            <div v-on:click.prevent="selectProduct(product)">
              <div class="md-title card-area-title">
                {{ product.name }}
                <span class="highlightColor highlightUpped">
                  ({{ product.size }})
                </span>
              </div>
            </div>
          </md-card-header>

          <md-card-content class="product-fields-content">
            <div v-on:click.prevent="selectProduct(product)">
              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">Заказ:</span>
                  <span class="item-strong-text">
                    <strong>
                      {{ product.orderNumber }}
                      <span
                        v-if="product.cartNumber > 0"
                        class="highlightColor highlightUpped"
                      >
                        (К{{ product.cartNumber }})
                      </span>
                    </strong>
                  </span>
                </p>
              </div>

              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">Вложить:</span>
                  <span class="item-strong-text">
                    <strong>
                      <span class="highlightColor">{{ product.quantity }}</span>
                      / {{ product.assembled }}
                    </strong>
                  </span>
                </p>
              </div>

              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">Cклад/Возвраты:</span>
                  <span class="item-strong-text">
                    <strong>
                      <span
                        v-if="product.quantity_on_storage"
                        class="highlightColor"
                      >
                        {{ product.quantity_on_storage }}
                      </span>
                      <span v-if="!product.quantity_on_storage">
                        {{ product.quantity_on_storage }}
                      </span>
                      /
                      <span
                        v-if="product.quantity_on_zel"
                        class="highlightColor"
                      >
                        {{ product.quantity_on_zel }}
                      </span>
                      <span v-if="!product.quantity_on_zel">
                        {{ product.quantity_on_zel }}
                      </span>
                    </strong>
                  </span>
                </p>
              </div>

              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">В куче:</span>
                  <span class="item-strong-text">
                    <strong>
                      <span
                        v-if="product.quantity_on_bunch"
                        class="highlightColor"
                      >
                        {{ product.quantity_on_bunch }}
                      </span>
                      <span v-if="!product.quantity_on_bunch">
                        {{ product.quantity_on_bunch }}
                      </span>
                    </strong>
                  </span>
                </p>
              </div>

              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">Цвет:</span>
                  <span class="item-strong-text">
                    <strong>{{ product.color }}</strong>
                  </span>
                </p>
              </div>

              <div class="md-layout-item product-fields-column">
                <p class="product-fields-item">
                  <span class="item-simple-text">Сортировка:</span>
                  <span class="item-strong-text">
                    <strong>{{ product.sort }}</strong>
                  </span>
                </p>
              </div>

              <div
                v-if="product.reminder && !product.quantity_on_storage"
                class="md-layout-item product-fields-column"
              >
                <p class="product-fields-item">
                  <span class="item-simple-text">Где лежит:</span>
                  <span class="item-strong-text">
                    <strong>{{ product.additional_info }}</strong>
                  </span>
                </p>
              </div>
            </div>
          </md-card-content>

          <md-card-actions class="md-layout custom-action">
            <md-button
              v-on:click.prevent="selectProduct(product)"
              v-if="
                product.reminder &&
                !product.quantity_on_storage &&
                !product.quantity_on_zel
              "
              class="placeButton md-layout-item"
            >
              <span class="reminderButtonText">{{ product.reminder }}</span>
            </md-button>
            <md-button
              v-on:click.prevent="selectProduct(product)"
              v-else
              class="placeButton md-layout-item"
            >
              <span class="placeButtonText">{{ product.additional_info }}</span>
            </md-button>
            <md-button
              v-if="
                product.barcodes.length &&
                product.quantity !== product.assembled
              "
              v-on:click.stop.prevent="barButton"
              class="md-layout-item md-size-20"
            >
              <span class="placeButtonText">
                <md-icon class="action-icon">code</md-icon>
              </span>
            </md-button>
          </md-card-actions>
        </md-card-area>
      </md-card-media-cover>
    </md-card>
    <md-dialog-alert-barcode
      v-if="product.barcodes.length"
      :md-active.sync="barCodeModal"
      :md-barcodes="product.barcodes"
    />
  </div>
</template>

<script>
  export default {
    name: "ShowProduct",
    props: ["product"],
    data: () => ({
      image: null,
      barCodeModal: false,
      dialog: false,
    }),
    created: function () {
      this.image = this.holder;
      const path = this.product.images.small[0];
      new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => resolve();

        img.onerror = () => reject();

        img.src = path;
      })
        .then(() => {
          this.image = path;
        })
        .catch(() => {
          this.$store.commit("messages/setMessage", {
            type: "warning",
            code: "Ой вей!",
            message: "Картинка к товару не была загружена",
          });
        });
    },
    watch: {
      product() {
        this.barCodeModal = false;
      },
    },
    computed: {
      holder() {
        return this.$store.state.holder.item;
      },
    },
    methods: {
      selectProduct: function (item) {
        this.$store.commit("product/setProduct", item);
      },
      barButton() {
        this.barCodeModal = true;
      },
      onCancel() {
        return;
      },
      onConfirm() {
        this.$store.commit("orders/makeProductAssembled", this.product);
        this.$store.commit("messages/setMessage", {
          type: "success",
          code: "Ну ок!",
          message: "Товар помечен, как собранный. А шо мы момжем возразить?",
        });
      },
      // imageSwipeHandler(direction) {
      //   const index = this.product.images.small.indexOf(this.image);

      //   if (direction === "top") {
      //     this.dialog = true;
      //   }

      //   if (direction === "right") {
      //     if (index - 1 >= 0) {
      //       this.image = this.product.images.small[index - 1];
      //     } else {
      //       this.image = this.product.images.small[
      //         this.product.images.small.length - 1
      //       ];
      //     }
      //   }

      //   if (direction === "left") {
      //     if (index + 1 <= this.product.images.small.length - 1) {
      //       this.image = this.product.images.small[index + 1];
      //     } else {
      //       this.image = this.product.images.small[0];
      //     }
      //   }
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .product {
    // content-visibility: auto;
  }
  .custom-action {
    text-align: center;
    padding: 0 6px;
  }
  .action-icon {
    color: #458dfa !important;
  }

  .placeButton {
    width: 100%;
    color: #458dfa !important;
    font-weight: 600;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .placeButtonText {
    color: #458dfa !important;
    @media (max-width: 800px) {
      font-size: 12px;
    }
  }

  .reminderButtonText {
    color: #ff5252 !important;
    @media (max-width: 800px) {
      font-size: 12px;
    }
  }

  .product-fields-content {
    font-size: 13px;
    line-height: 1em;
    padding: 0 6px;
    @media (max-width: 800px) {
      padding: 0;
      font-size: 12px;
    }
  }

  .product-fields-column {
    padding: 0 6px;
    margin: 0;
  }

  .product-fields-item {
    padding: 0;
    margin: 6px 0;
    @media (max-width: 800px) {
      margin: 4px 0;
    }
  }

  .item-simple-text {
    font-size: 14px;
    @media (max-width: 800px) {
      font-size: 12px;
    }
  }

  .highlightColor {
    color: #fffb03;
    font-weight: 600;
  }

  .highlightUpped {
    text-transform: uppercase;
  }

  .md-card-header {
    background-color: none;
    padding: 2px 2px;
    /*position: absolute;*/
    /*z-index: 100;*/
    /*top: 0*/
  }

  .md-card-content {
    margin: 0;
  }

  .md-card-media {
    /*position: absolute;*/
    /*z-index: 100;*/
    /*top: 20px;*/
  }

  .md-card .md-title {
    font-size: 18px;
    line-height: 1.2em;
    padding-left: 8px;
    margin: 0;
    @media (max-width: 800px) {
      font-size: 14px;
      padding-left: 4px;
    }
  }

  .md-app-content .md-card {
    margin: 0 5px;
    margin-bottom: 20px;
  }

  .md-card-example {
    .md-subhead {
      .md-icon {
        $size: 16px;

        width: $size;
        min-width: $size;
        height: $size;
        font-size: $size !important;
      }

      span {
        vertical-align: middle;
      }
    }

    .card-reservation {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .md-icon {
        margin: 8px;
      }
    }

    .md-button-group {
      display: flex;

      .md-button {
        min-width: 60px;
        border-radius: 2px;
      }
    }
  }
  .card-area {
    background-color: rgba(0, 0, 0, 0.65);
    padding: 8px;
  }
  .custom-overflow-card-header {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
  }
</style>
